import React from "react";
import { useNavigate } from "react-router-dom";
import img from "../../assets/images/jeep.jpg";
import useReviews from "../../hooks/useReviews";
import Review from "../Review/Review";

const Home = () => {
    const navigate=useNavigate()
    const [reviews] = useReviews();
    const threeReviews=reviews.slice(0,3)
  return (
    <div>
      <section className="md:flex justify-center items-center m-6 ">
        <div className="md:w-1/2 mr-6">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Mans dream <br />{" "}
            <span className="text-blue-700">JEEP wrangler</span>
          </h1>
          <p className="text-xl text-gray-500">
            Jeep has been talking about an electrified future, and it's going
            make that talk a reality with an EV version of the brand's iconic
            Wrangler off-roader. That concept vehicle, called Magneto, featured
            four chassis-mounted battery packs positioned for optimum weight
            distribution.The company indicates the electric Wrangler may also
            have a feature that enables it to recharge other EVs. Jeep already
            sells a plug-in hybrid version of the Wrangler called the 4xe, so it
            seems likely that a fully-electric version isn't far off.
          </p>
        </div>
        <div className="md:w-1/2 h-[80vh] ">
          <img className="w-full h-full object-cover" src={img} alt="" />
        </div>
      </section>
      <section>
        <h1 className="text-4xl font-bold text-center pt-5">
          Customer Reviews(3)
        </h1>
        <div className="mt-20 grid md:grid-cols-3 gap-5 m-5">
          {threeReviews.map((review) => (
            <Review key={review.id} review={review} />
          ))}
        </div>
        <div className="flex justify-center mb-10">
          <button
            onClick={() => navigate("/reviews")}
            className="bg-blue-900 hover:bg-blue-600 text-2xl px-10 py-1 rounded-3xl text-white"
          >
            See all Reviews
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
